import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule, PopupLoaderModule } from "@app/shared";
import { LeafLetFullMapViewModalComponent } from "./leaf-let-full-map-view.component";
import { SharedLeafLetComponent } from "./shared-leaf-let.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { DialogModule } from "primeng/dialog";
@NgModule({
  declarations: [SharedLeafLetComponent, LeafLetFullMapViewModalComponent],
  imports: [
    MaterialModule, CommonModule, FormsModule, ReactiveFormsModule,
    PopupLoaderModule,ProgressSpinnerModule, DialogModule
  ],
  entryComponents:[LeafLetFullMapViewModalComponent],
  exports: [SharedLeafLetComponent, LeafLetFullMapViewModalComponent]
})
export class LeafletComponentsModule { }